export default "__VITE_ASSET__B2b3oEbH__"